const initGuardarApuntes = () => {
    const textarea = document.querySelector('#apuntes');

    if (!textarea) return;

    let timer = null;

    textarea.addEventListener('input', function () {
        clearTimeout(timer);

        timer = setTimeout(() => {
            fetch('/wp-json/guardar-apuntes-rest/v1/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': guardar_apunte_nonce.apiNonce
                },
                body: JSON.stringify({
                    data: {
                        id_lesson: textarea.dataset.lesson,
                        id_course: textarea.dataset.course,
                        id_user: textarea.dataset.user,
                        apunte: textarea.value
                    }
                })
            })
            .then(response => response.json())
            .then(response => {
                if (!response.success) return;
            })
            .catch(error => {
                console.error('Error filtrando apuntes:', error);
            })
            .finally(() => {
                
            });
        }, 700);
    });
};


export default initGuardarApuntes;